import Modal from "react-bootstrap/Modal";
import * as announcementSelectors from "../../../../selectors/announcement";

function AnnouncementModal({ showModal, setShowModal, item }) {
  const title = announcementSelectors.getAnnouncementDetailTitle(item);
  const updatedAt = announcementSelectors.getAnnouncementDetailUpdatedAtText(item);
  const content = announcementSelectors.getAnnouncementDetailContent(item);
  return (
    <Modal size={"lg"} centered={true} show={showModal} onHide={() => setShowModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title className={"annoucement-modal-title"}>Announcement</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={"annoucement-modal-sub-title d-flex justify-content-between"}>
          <p>{title}</p>
          <p>{updatedAt}</p>
        </div>
        <div dangerouslySetInnerHTML={{ __html: content }}></div>
      </Modal.Body>
    </Modal>
  );
}

export default AnnouncementModal;
